<template>
  <v-form v-if="dialog" v-model="valid" ref="form">
    <v-dialog v-model="dialog" persistent scrollable width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Relatório de Durações de Participantes
          <div style="position: absolute; top: 0; right: 10px">
            <v-tooltip top style="padding-bottom: 50px">
              <v-icon slot="activator" color="black">{{'info'}}</v-icon>
              <span>Apenas administradores da empresa conseguem ter acesso a todos os participantes e filtros desse relatório</span>
            </v-tooltip>
          </div>
        </v-card-title>
        <v-card-text>
          <v-layout wrap justify-left align-center>
            <v-flex xs12>
              <v-flex xs12> 
                <v-text-field v-if="editedItem.selectedCompanyUser" ref="connectionIllis" disabled
                :label="translate('table.company_user.title')[0]" :value="editedItem.id_text">
                </v-text-field>
                <p-select-multiple 
                  v-else :loading="loading" persistent-hint :hint="permission ? '' : 'Apenas administradores podem visualizar todos os participantes.'" :label="translate('table.company_user.title')[0]" :readonly="loading" 
                  :filter="filterAutocomplete"
                  :rules="requiredRule(translate('table.company_user.title')[0])"
                  v-model="editedItem.company_users" :items="itemsCompanyUsers" item_text="id_text" item_value="id"
                ></p-select-multiple>
              </v-flex>
            </v-flex>
            <v-flex xs12 sm6>
              <p-select-multiple
                :loading="loading" :label="translate('table.teams.title')[0]" :readonly="loading" :filter="filterAutocomplete"
                :rules="requiredRule(translate('table.teams.title')[0])"  v-model="editedItem.teams" :items="itemsTeams" item_text="id_text" item_value="id" @change="changeTeams"
              ></p-select-multiple>
            </v-flex>
            <v-flex xs12 sm6>
                <p-select-multiple
                  :loading="loading" :label="translate('table.task_category.title')[0]" :readonly="loading" :filter="filterAutocomplete"
                  :rules="requiredRule(translate('table.task_category.title')[0])"  v-model="editedItem.categories" :items="itemsCategories" item_text="id_text" item_value="id"
                ></p-select-multiple>
            </v-flex>
            <v-flex xs12 sm6>
              <p-date-time :label="translate('table.' + entity + '.field.begin')"
                           v-model="editedItem.begin"
                           :defaultHour="'00:00'"
                           :disabled="!checkPlanAccess('reports_everyday', 'has')"
                           :rules="dateDiffRule()">
              </p-date-time>
            </v-flex>
            <v-flex xs12 sm6>
              <p-date-time :label="translate('table.' + entity + '.field.end')"
                           v-model="editedItem.end"
                           :disabled="!checkPlanAccess('reports_everyday', 'has')"
                           :defaultHour="'23:59'"
                           :rules="dateDiffRule()">
              </p-date-time>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" class="mx-1" color="primary darken-1" @click='openReport(1)'>PDF</v-btn>
          <v-btn :loading="loading" class="mx-1" color="primary darken-2" @click='openReport(2)'>Excel</v-btn>
          <v-btn class="mx-1" :loading="loading" @click="close">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
  import rules from './../../mixin/rules'
  import plan from './../../mixin/plan'
  import PDateTime from './../shared/PDateTime'
  import PDate from './../shared/PDate'
  import PSelectMultiple from './../shared/PSelectMultiple'
  import access from './../../mixin/access'

  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'

  momentDurationFormatSetup(moment)
  export default {
    mixins: [rules, plan, access],
    name: 'PCompanyUserDuration',
    components: {
      PDateTime,
      PDate,
      PSelectMultiple
    },
    data: () => ({
      itemsCompanyUsers: [],
      itemsCategories: [],
      itemsTeams: [],
      valid: false,
      editedItem: {company_users: [], teams: [], categories: [], begin: '', end: '', id_text: '', selectedCompanyUser: false},
      defaultItem: {company_users: [], teams: [], categories: [], begin: '', end: '', id_text: '', selectedCompanyUser: false},
      entity: 'task_duration',
      dialog: false,
      permission: false,
      loading: true
    }),
    props: {},
    methods: {
      openReport: function (type) {
        if (!this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'warning',
            dialog: true
          })
          return false
        }
        let params = ''
        if (this.editedItem.company_users.length > 0) {
          params = `company_users=${JSON.stringify(this.editedItem.company_users)}`
        }
        if (this.editedItem.teams.length > 0) {
          params = params + `&teams=${JSON.stringify(this.editedItem.teams)}`
        }
        if (this.editedItem.categories.length > 0) {
          params = params + `&categories=${JSON.stringify(this.editedItem.categories)}`
        }
        if (this.editedItem.begin !== '') {
          params = params + '&begin=' + this.editedItem.begin
        }
        if (this.editedItem.end !== '') {
          params = params + '&end=' + this.editedItem.end
        }
        if (type === 1) {
          params = params + '&type=' + 1
        } else {
          params = params + '&type=' + 2
        }
        this.loading = true
        this.$store.commit('loader/change_dialog', true)
        this.$http.get(`api/report/companyUser/duration?${params}`).then(res => {
          let fileName = res.bodyText
          window.open(process.env.API + 'uploads/reports/' + fileName, '_blank')
          let _this = this
          setTimeout(function () {
            _this.$http.delete(`api/delete_upload_report/${fileName}`)
          }, 5000)
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
        }, (err) => {
          if (err.body.message === 'accessDenied') {
            this.$store.commit('snackbar/change_values', {timeout: 12000, text: 'Você não possui acesso para esse relatório.', color: 'warning', dialog: true})
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível abrir esse relatório, reporte o erro.', color: 'error', dialog: true})
            alert('Erro! Falha ao enviar a requisição.')
          }
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
        })
      },
      openDialog: function (companyUserId = '', idText = '') {
        this.loading = true
        this.dialog = true
        this.permission = false
        this.permission = this.$auth.user()['admin']
        this.editedItem.begin = moment().format('YYYY-MM-DD 00:00')
        this.editedItem.end = moment().format('YYYY-MM-DD 23:59')
        this.$http.get('api/report_company_user_filters/' + this.permission).then(res => {
          this.itemsCategories = res.body['categories']
          this.itemsTeams = res.body['teams']
          this.loading = false
          if (companyUserId !== '') {
            this.editedItem.id_text = idText
            this.editedItem.selectedCompanyUser = true
            this.editedItem.company_users = [companyUserId]
          } else {
            this.itemsCompanyUsers = res.body['company_user']
          }
        }, err => {
          console.log(err, 'err')
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os registros, reporte o erro.', color: 'error', dialog: true})
          this.loading = false
        })
      },
      changeTeams (val) {
        let params = `permission=${this.$auth.user()['admin']}&teams=${val}`
        this.loading = true
        this.$http.get(`api/get_users_by_hierarchy?${params}`).then(res => {
          // Serve para tirar pessoa que foram selecionadas mas ao mudarem a equipe deixaram de existir
          if (this.editedItem.company_users) {
            this.editedItem.company_users = []
          }
          this.itemsCompanyUsers = res.body
          this.loading = false
        })
      },
      filterAutocomplete (item, queryText, itemText) {
        const hasValue = val => val != null ? val : ''
        const text = hasValue(itemText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const query = hasValue(queryText).toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        return text.indexOf(query) > -1
      },
      close: function () {
        this.dialog = false
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(this.defaultItem)))
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/PCompanyUserDuration.vue